// src/paymentDefs.js
// ここに“すべてのフロント側の決済定義”を集約します。

export const LABELS = {
  // --- クレジット/デビット（カード） ---
  // 国際ブランド：タッチ決済あり/なし
  visa_touch: 'Visa（タッチ決済あり）', visa_no_touch: 'Visa（タッチ決済なし）', mastercard_touch: 'Mastercard（タッチ決済あり）', mastercard_no_touch: 'Mastercard（タッチ決済なし）', jcb_touch: 'JCB（タッチ決済あり）', jcb_no_touch: 'JCB（タッチ決済なし）', amex_touch: 'American Express（タッチ決済あり）', amex_no_touch: 'American Express（タッチ決済なし）', diners_touch: 'Diners Club（タッチ決済あり）', diners_no_touch: 'Diners Club（タッチ決済なし）', discover_touch: 'Discover（タッチ決済あり）', discover_no_touch: 'Discover（タッチ決済なし）', unionpay_touch: '銀聯（タッチ決済あり）', unionpay_no_touch: '銀聯（タッチ決済なし）',

  // --- 電子マネー ---
  id: 'iD', quicpay: 'QUICPay', rakuten_edy: '楽天Edy', waon: 'WAON', nanaco: 'nanaco',

  // --- 交通系IC（全国相互利用 10種 + PiTaPa） ---
  suica: 'Suica', pasmo: 'PASMO', icoca: 'ICOCA', toica: 'TOICA', manaca: 'manaca',
  kitaca: 'Kitaca', sugoca: 'SUGOCA', nimoca: 'nimoca', hayakaken: 'はやかけん', pitapa: 'PiTaPa',

  // --- QR/バーコード（国内メジャー） ---
  paypay: 'PayPay', dbarai: 'd払い', rakuten_pay: '楽天ペイ', aupay: 'au PAY',
  merpay: 'メルペイ', famipay: 'FamiPay', aeon_pay: 'AEON Pay',
  jcoin_pay: 'J-Coin Pay', bank_pay: 'BankPay',paidy: 'Paidy（後払い）', giftee_premo_plus: 'ギフティプレモPlus',

  // --- 銀行Pay（BankPay 配下の主な地域ブランド） ---
  yucho_pay: 'ゆうちょPay', yoka_pay: 'YOKA!Pay', oki_pay: 'OKI Pay',
  hama_pay: 'はまPay', koi_pay: 'こいPay',

  // --- Smart Code 参加（代表例） ---
  atone: 'atone', pring: 'pring', epos_pay: 'EPOS PAY',
  ana_pay: 'ANA Pay', jal_pay: 'JAL Pay', bnpj_pay: 'BNPJ Pay',
  luvit_pay: 'Lu Vit Pay', paydon: 'Payどん', wesmo: 'Wesmo!', myjcb_pay: 'MyJCB Pay',

  // --- インバウンド QR等 ---
  alipay: 'Alipay', wechat_pay: 'WeChat Pay', gln_pay: 'GLN Pay',

  // 地域デジタル通貨（代表）
  local_regional: '地域デジタル通貨',

  // --- スマホウォレット（NFCタッチの入れ物） ---
  apple_pay: 'Apple Pay', google_pay: 'Google Pay',
};

export const BRAND_COLOR = {
  // card
  visa_touch: '#1A1F71', visa_no_touch: '#1A1F71', mastercard_touch: '#EB001B', mastercard_no_touch: '#EB001B', jcb_touch: '#0A6FBB', jcb_no_touch: '#0A6FBB', amex_touch: '#2E77BC', amex_no_touch: '#2E77BC', diners_touch: '#006272', diners_no_touch: '#006272', discover_touch: '#F76C00', discover_no_touch: '#F76C00', unionpay_no_touch: '#2e8b57', unionpay_touch: '#2e8b57',

  // e-money
  id: '#ffc107', quicpay: '#005bac', rakuten_edy: '#be0026', waon: '#00a1e9', nanaco: '#9c7a35',

  // transit IC
  suica: '#6bc200', pasmo: '#ff4f8b', icoca: '#00a6de', toica: '#00a0c6', manaca: '#1e1e1e',
  kitaca: '#8cc63f', sugoca: '#ff6cae', nimoca: '#7dc8f7', hayakaken: '#77c4d3', pitapa: '#7a67aa',

  // QR - domestic
  paypay: '#e60012', dbarai: '#c80000', rakuten_pay: '#bf0000', aupay: '#f08300',
  merpay: '#ff4d4d', famipay: '#00a651', aeon_pay: '#9d2f7f',
  jcoin_pay: '#e6007e', bank_pay: '#0071bc', paidy: '#ff1f8e', giftee_premo_plus: '#00b5ad',

  // bank pay sub-brands
  yucho_pay: '#2fb36f', yoka_pay: '#007ac1', oki_pay: '#e60012',
  hama_pay: '#0073cf', koi_pay: '#d23950',

  // Smart Code examples
  atone: '#00a0e9', pring: '#f2c94c', epos_pay: '#c8002d',
  ana_pay: '#0071bc', jal_pay: '#e6002d', bnpj_pay: '#2c3e50',
  luvit_pay: '#e67e22', paydon: '#f39c12', wesmo: '#6f42c1', myjcb_pay: '#0b4da2',

  // inbound
  alipay: '#00a1e9', wechat_pay: '#20ad3a', gln_pay: '#f57c00',

  // local
  local_regional: '#6B7280',

  // wallets
  apple_pay: '#000000', google_pay: '#4285f4',
};

// カテゴリごとの並び。UI のフィルタに使う。
export const PM_GROUPS = {
  qr: [
    'paypay','dbarai','rakuten_pay','aupay','merpay','famipay','aeon_pay',
    'jcoin_pay','bank_pay',
    // 銀行Payの主な地域系
    'yucho_pay','yoka_pay','oki_pay','hama_pay','koi_pay',
    // Smart Code 代表例
    'atone','pring','epos_pay','ana_pay','jal_pay','bnpj_pay','luvit_pay','paydon','wesmo','myjcb_pay', 'paidy','giftee_premo_plus',
    // インバウンド
    'alipay','wechat_pay', 'gln_pay',
  ],
  emoney: [
    'id','quicpay','rakuten_edy','waon','nanaco',
    // 交通系ICも“電子マネー”として使われるのでここに含めておく（UIでは分けてもOK）
    'suica','pasmo','icoca','toica','manaca','kitaca','sugoca','nimoca','hayakaken','pitapa',
  ],
  card: ['visa_touch','visa_no_touch', 'mastercard_touch','mastercard_no_touch', 'jcb_touch','jcb_no_touch', 'amex_touch','amex_no_touch', 'diners_touch','diners_no_touch', 'discover_touch','discover_no_touch', 'unionpay_no_touch', 'unionpay_touch'],
  wallet: ['apple_pay','google_pay'],
  local: ['local_regional'],
};

// 丸アイコン内に表示する2文字略称（未指定は自動で先頭2文字）
export const ICON_CHAR = {
  // cards
  visa: 'VI', mastercard: 'MC', jcb: 'JCB', amex: 'AE', diners: 'DN', discover: 'DS', unionpay: 'UP',
  // emoney
  id: 'iD', quicpay: 'QP', rakuten_edy: 'RE', waon: 'WN', nanaco: 'NA',
  suica: 'Su', pasmo: 'Pa', icoca: 'Ic', toica: 'To', manaca: 'Ma', kitaca: 'Ki', sugoca: 'SuG', nimoca: 'Ni', hayakaken: 'Ha', pitapa: 'Pi',
  // QR domestic
  paypay: 'PP', dbarai: 'd払', rakuten_pay: '楽P', aupay: 'au', merpay: 'Me',
  famipay: 'Fa', aeon_pay: 'AE', jcoin_pay: 'JC', bank_pay: 'BK', paidy: 'Pa', giftee_premo_plus: 'GP',
  // bank pay subs
  yucho_pay: 'ゆう', yoka_pay: 'Y!', oki_pay: 'OK', hama_pay: '浜', koi_pay: '鯉',
  // Smart Code ex.
  atone: 'AT', pring: 'PR', epos_pay: 'EP', ana_pay: 'AN', jal_pay: 'JA', bnpj_pay: 'BN',
  luvit_pay: 'LV', paydon: 'PD', wesmo: 'WM', myjcb_pay: 'MJ',
  // inbound
  alipay: 'AL', wechat_pay: 'WC', gln_pay: 'GL',
  // wallets
  apple_pay: 'AP', google_pay: 'GP',
};

// 同一ブランドのタッチ/非タッチを相互排他にするためのマップ
export const CARD_TOUCH_MUTEX = {
  visa_touch: 'visa_no_touch',           visa_no_touch: 'visa_touch',
  mastercard_touch: 'mastercard_no_touch', mastercard_no_touch: 'mastercard_touch',
  jcb_touch: 'jcb_no_touch',             jcb_no_touch: 'jcb_touch',
  amex_touch: 'amex_no_touch',           amex_no_touch: 'amex_touch',
  diners_touch: 'diners_no_touch',       diners_no_touch: 'diners_touch',
  discover_touch: 'discover_no_touch',   discover_no_touch: 'discover_touch',
  unionpay_touch: 'unionpay_no_touch',   unionpay_no_touch: 'unionpay_touch',
};


// バッジ（検索候補や吹き出し、一覧に共通利用）
export function PaymentIcon({ id, size = 22, style }) {
  const label = LABELS[id] || id;
  const bg = BRAND_COLOR[id] || '#555';
  const txt = ICON_CHAR[id] || (label.length >= 2 ? label.slice(0, 2) : label);
  const px = typeof size === 'number' ? `${size}px` : size;
  return (
    <span
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: px, height: px,
        borderRadius: 999,
        fontSize: Math.max(10, Math.floor((parseInt(px, 10) || 22) * 0.55)),
        color: '#fff',
        background: bg,
        lineHeight: 1,
        ...style,
      }}
    >
      {txt}
    </span>
  );
}
